import EventBus,{ EventName } from '../../../Shared/Assets/event-bus';
import { sendGAEvent } from '../../../Shared/Assets/utils';

import SellerPhoneNumber from './seller-phone-number';
import VerifyPhoneNumber from './verify-phone-number';
import VerifyCode from './verify-code';



(function ($, w) {
    $("form[seller-phone-number]").each(function () {
        new SellerPhoneNumber().init(this);
    });

    var initVerifyPhoneTimeout = null;

    let initVerifyPhoneNumber = () => {
        if (initVerifyPhoneTimeout) {
            clearTimeout(initVerifyPhoneTimeout);
        }

        initVerifyPhoneTimeout = setTimeout(() => {
            let initCount = 0;
            $("form[verify-phone-number]").each(function () {
                let successInit = new VerifyPhoneNumber().init(this);
                if (successInit) {
                    initCount++;
                }
            });

            if (initCount > 0) {
                sendGAEvent('sms verification', 'number entry form', 'view');
            }
        }, 100);
    };

    var initVerifyCodeFormTimeout = null;
    let initVerifyCodeForm = () => {
        if (initVerifyCodeFormTimeout) {
            clearTimeout(initVerifyCodeFormTimeout);
        }

        initVerifyCodeFormTimeout = setTimeout(() => {
            let initCount = 0;
            $("form[verify-code]").each(function () {
                let successInit = new VerifyCode().init(this);
                if (successInit) {
                    initCount++;
                }
            });

            if (initCount > 0) {
                sendGAEvent('sms verification', 'code entry form', 'view');
            }
        }, 100);
    };

    let eventBus = new EventBus();
    eventBus.handle(EventName.InitVerifyPhoneNumberForm, initVerifyPhoneNumber);
    eventBus.handle(EventName.InitVerifyCodeForm, initVerifyCodeForm);
})(jQuery, window);